<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import PatientQrPublicAddForm from "@/components/models/patient/forms/PatientQrPublicAddForm.vue";

definePage({
  meta: {
    title: "models.patient.publicAddForm.title",
    requiresAuth: false,
    layout: "public",
  },
});
</script>

<template>
  <v-skeleton-loader>
    <patient-qr-public-add-form />
  </v-skeleton-loader>
</template>

<style scoped></style>
